export default "__VITE_ASSET__Dm2wNQVj__"